import styled from '@emotion/styled';

export const Title = styled.span<{ isHeroCard?: boolean }>`
  ${({ isHeroCard }) => `
    font-size: ${isHeroCard ? '4.5rem' : '1.5rem'};
  `}
`;

export const Shape = styled.div<{ isHeroCard?: boolean }>`
  ${({ isHeroCard }) => `
    border-style: solid;
    border-width: ${isHeroCard ? '2px' : '1px'};
    border-radius:  ${isHeroCard ? '1.5rem' : '1rem'};
  `}
`;

export const PlayIcon = styled.div<{ isHeroCard?: boolean }>`
  ${({ isHeroCard }) => `
    top: ${isHeroCard ? '1.5rem' : '1rem'};
    right: ${isHeroCard ? '1.5rem' : '1rem'};
    width: ${isHeroCard ? '2.75rem' : '2rem'};
    height: ${isHeroCard ? '2.75rem' : '2rem'};
    position: absolute;
    backdrop-filter: blur(3px);
    background: rgba(256, 256, 256, 0.8);
  `}
`;
